import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import ProductsV1 from './containers/Products';
import { ProductsV2 } from './v2';

type ProductsVersionProps = {
  id?: string | string[];
};

export const ProductsVersion: FC<ProductsVersionProps> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <ProductsV2 {...props} />;
  return <ProductsV1 {...props} />;
};
